// ── Cart helpers ─────────────────────────────────────────────────────────────

function getCartDrawer() {
  return document.querySelector('cart-drawer');
}

function openCartDrawer() {
  var drawer = getCartDrawer();
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
  }
}

// 29/09/2026 (BUG-03) : routes relues dans Shopify.routes.root (langue de la page), jamais « / » en dur.
function mngRacine() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
}

async function addToCartAndRefresh(formData) {
  var res = await fetch(mngRacine() + 'cart/add.js', { method: 'POST', body: formData });
  if (!res.ok) throw new Error('Cart add failed: ' + res.status);
  var cartRes = await fetch(mngRacine() + 'cart.js', { headers: { Accept: 'application/json' } });
  if (!cartRes.ok) throw new Error('Cart fetch failed');
  var cart = await cartRes.json();
  var drawer = getCartDrawer();
  if (drawer && typeof drawer.refreshFromCart === 'function') {
    drawer.refreshFromCart(cart);
  } else {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    openCartDrawer();
  }
}

// ── DOMContentLoaded ─────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', function () {

  // ── Cart: intercept ATC form submissions (delegated, includes dynamic forms) ──
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    // 29/09/2026 (BUG-03) : /cart/add et ses versions localisées (/it/cart/add, /es/cart/add…).
    if (!form || !form.matches || !form.matches('form[action$="/cart/add"]')) return;
    if (form.closest('cart-drawer') || form.hasAttribute('data-cart-drawer-suggestion-form')) return;
    if (event.defaultPrevented) return;
    if (form.dataset.cartSubmitting === '1') return;
    event.preventDefault();
    form.dataset.cartSubmitting = '1';
    try {
      await addToCartAndRefresh(new FormData(form));
    } catch (err) {
      console.error('Add to cart error:', err);
    } finally {
      delete form.dataset.cartSubmitting;
    }
  });

  // ── Cart: /cart links → open drawer instead of navigating ────────────────
  document.querySelectorAll('a[href="/cart"], button[data-href="/cart"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  // ── Mobile product slider (#slider10) ───────────────────────────────────
  if (window.innerWidth < 768) {
    var slider10El = document.getElementById('slider10');
    if (slider10El) {
      new Splide('#slider10', { type: 'slide', perPage: 1, arrows: false, pagination: true }).mount();
    }
  }

  // ── Product image carousel (main + thumbnails Splide) ───────────────────
  var mainCarousel = document.getElementById('main-carousel');
  var thumbnailCarousel = document.getElementById('thumbnail-carousel');
  if (mainCarousel && thumbnailCarousel) {
    var main = new Splide('#main-carousel', { type: 'fade', rewind: true, pagination: false, arrows: false });
    var thumbnails = new Splide('#thumbnail-carousel', {
      fixedWidth: 100, fixedHeight: 100, gap: 10, rewind: true, pagination: false,
      isNavigation: true, focus: 'center',
      breakpoints: { 600: { fixedWidth: 75, fixedHeight: 75 } }
    });
    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }

  // ── Variant label radio selection ────────────────────────────────────────
  document.querySelectorAll('.variant-label input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', function () {
      document.querySelectorAll('.variant-label').forEach(function (label) {
        label.classList.remove('selected');
      });
      this.closest('.variant-label').classList.add('selected');
    });
  });
  var initiallyChecked = document.querySelector('.variant-label input[type="radio"]:checked');
  if (initiallyChecked) initiallyChecked.dispatchEvent(new Event('change'));

  // ── Checkout button ID assignment (for third-party integrations) ─────────
  var checkButtonInterval = setInterval(function () {
    var btn = document.querySelector(
      'button[data-ocu-checkout="true"][name="checkout"].hs-checkout-purchase.checkout-x-buy-now-btn'
    );
    if (btn) {
      btn.id = 'checkoutButtonId';
      clearInterval(checkButtonInterval);
    }
  }, 500);
  // Stop polling after 10s max to avoid infinite loop
  setTimeout(function () { clearInterval(checkButtonInterval); }, 10000);

  // ── Product image gallery (thumbnails, prev/next, swipe) ─────────────────
  var currentImageIndex = 0;
  var mainImageMobile = document.getElementById('main-image-mobile');
  var mainImageDesktop = document.getElementById('main-image-desktop');
  var mainImage = document.getElementById('main-image');
  var galleryThumbs = document.querySelectorAll('.thumbnail');
  var previewThumbs = document.querySelectorAll('.preview-thumbnail');
  var previewContainer = document.getElementById('preview-thumbnails-container');

  function updateImage(index) {
    if (!galleryThumbs.length) return;
    currentImageIndex = index;
    var imageUrl = galleryThumbs[index] && galleryThumbs[index].dataset.image;
    if (!imageUrl) return;
    if (mainImageMobile) mainImageMobile.src = imageUrl;
    if (mainImageDesktop) mainImageDesktop.src = imageUrl;
    if (mainImage) mainImage.src = imageUrl;
    galleryThumbs.forEach(function (t) { t.classList.remove('bg-purple'); });
    previewThumbs.forEach(function (t) { t.classList.remove('bg-purple'); });
    galleryThumbs[index].classList.add('bg-purple');
    if (previewThumbs[index]) previewThumbs[index].classList.add('bg-purple');
    if (previewContainer && previewThumbs[index]) {
      var active = previewThumbs[index];
      previewContainer.scroll({
        left: active.offsetLeft - previewContainer.clientWidth / 2 + active.clientWidth / 2,
        behavior: 'smooth'
      });
    }
  }

  if (galleryThumbs.length > 0) updateImage(currentImageIndex);

  var prevBtn = document.getElementById('prev-btn');
  if (prevBtn) prevBtn.addEventListener('click', function () {
    updateImage(currentImageIndex > 0 ? currentImageIndex - 1 : galleryThumbs.length - 1);
  });

  var nextBtn = document.getElementById('next-btn');
  if (nextBtn) nextBtn.addEventListener('click', function () {
    updateImage(currentImageIndex < galleryThumbs.length - 1 ? currentImageIndex + 1 : 0);
  });

  galleryThumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { updateImage(i); });
  });
  previewThumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { updateImage(i); });
  });

  // Arrow key navigation — only if a product gallery exists on this page
  if (galleryThumbs.length > 0) {
    document.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        updateImage(currentImageIndex > 0 ? currentImageIndex - 1 : galleryThumbs.length - 1);
      } else if (event.key === 'ArrowRight') {
        updateImage(currentImageIndex < galleryThumbs.length - 1 ? currentImageIndex + 1 : 0);
      }
    });
  }

  var touchStartX = 0;
  function handleTouchStart(e) { touchStartX = e.changedTouches[0].screenX; }
  function handleTouchEnd(e) {
    var delta = e.changedTouches[0].screenX - touchStartX;
    if (delta < -50) updateImage(currentImageIndex < galleryThumbs.length - 1 ? currentImageIndex + 1 : 0);
    else if (delta > 50) updateImage(currentImageIndex > 0 ? currentImageIndex - 1 : galleryThumbs.length - 1);
  }
  [mainImageMobile, mainImageDesktop, mainImage].forEach(function (el) {
    if (el) {
      el.addEventListener('touchstart', handleTouchStart, { passive: true });
      el.addEventListener('touchend', handleTouchEnd, { passive: true });
    }
  });

  // ── Add to Cart button (legacy button-based, not form) ───────────────────
  // Add to Cart button (legacy button-based) — uses shared addToCartAndRefresh
  var addToCartBtn = document.getElementById('add-to-cart-btn');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async function () {
      var variantId = this.dataset.variantId;
      if (!variantId) return;
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      try {
        await addToCartAndRefresh(formData);
      } catch (err) {
        console.error('Add to cart error:', err);
      }
    });
  }

  // ── Accordion ────────────────────────────────────────────────────────────
  var accordions = [
    { container: 'description-container', content: 'description-content', toggle: 'toggle-description' },
    { container: 'why-container',         content: 'why-content',         toggle: 'toggle-why' },
    { container: 'ingredients-container', content: 'ingredients-content', toggle: 'toggle-ingredients' },
    { container: 'satisfaction-container',content: 'satisfaction-content',toggle: 'toggle-satisfaction' },
    { container: 'analyses-container',    content: 'analyses-content',    toggle: 'toggle-analyses' },
    { container: 'shipping-container',    content: 'shipping-content',    toggle: 'toggle-shipping' },
    { container: 'prep-container',        content: 'prep-content',        toggle: 'toggle-prep' }
  ];

  function closeAllAccordions() {
    accordions.forEach(function (acc) {
      var content = document.getElementById(acc.content);
      var btn = document.getElementById(acc.toggle);
      if (content && btn) { content.classList.add('hidden'); btn.textContent = '+'; }
    });
  }

  accordions.forEach(function (accordion) {
    var container = document.getElementById(accordion.container);
    var content   = document.getElementById(accordion.content);
    var btn       = document.getElementById(accordion.toggle);
    if (container && content && btn) {
      container.addEventListener('click', function () {
        if (content.classList.contains('hidden')) {
          closeAllAccordions();
          content.classList.remove('hidden');
          btn.textContent = '-';
        } else {
          content.classList.add('hidden');
          btn.textContent = '+';
        }
      });
    }
  });

});

// ── Variant options – dynamic price update (runs at load, elements exist) ────
(function () {
  var shopCurrency = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active)
    ? Shopify.currency.active : 'EUR';
  var variantOptions = document.querySelectorAll('.variant-option');
  var addToCartBtn   = document.getElementById('add-to-cart-btn');
  var dynamicPrice   = document.getElementById('dynamic-price');

  variantOptions.forEach(function (option) {
    option.addEventListener('click', function () {
      var selectedVariantId    = this.dataset.variantId;
      var selectedVariantPrice = this.dataset.price;
      var isOutOfStock         = this.dataset.available === 'false';

      if (addToCartBtn) {
        if (isOutOfStock) {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('opacity-50', 'cursor-not-allowed');
        } else {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('opacity-50', 'cursor-not-allowed');
          addToCartBtn.dataset.variantId = selectedVariantId;
          var priceStr = new Intl.NumberFormat('en-US', { style: 'currency', currency: shopCurrency })
            .format(selectedVariantPrice / 100);
          var preorderEl = document.querySelector('[data-preorder="true"]');
          if (preorderEl) {
            var preorderText = document.querySelector('[data-preorder-text]').dataset.preorderText;
            addToCartBtn.innerHTML = preorderText + ' - ' + priceStr;
          } else {
            addToCartBtn.textContent = 'Ajouter au panier - ' + priceStr;
          }
          if (dynamicPrice) dynamicPrice.textContent = priceStr;
        }
      }
      var newUrl = window.location.pathname + '?variant=' + selectedVariantId;
      window.history.pushState({ path: newUrl }, '', newUrl);
    });
  });
})();

// ── Global helpers (called from Liquid templates) ─────────────────────────────

function toggleText(ingredientId) {
  var element = document.getElementById(ingredientId);
  if (!element) return;
  var shortText = element.querySelector('.short-text');
  var longText  = element.querySelector('.long-text');
  if (shortText.classList.contains('hidden')) {
    shortText.classList.remove('hidden');
    longText.classList.add('hidden');
    element.classList.remove('!bg-opacity-30');
  } else {
    shortText.classList.add('hidden');
    longText.classList.remove('hidden');
    element.classList.add('!bg-opacity-30');
  }
}

function toggleSection(sectionId) {
  if (typeof setActiveButtonAndSection === 'function') setActiveButtonAndSection(sectionId);
}

function scrollToProductInfo() {
  var el = document.getElementById('product-info');
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}
